import { useMemo, useState } from 'react';
import { Button, FormControl, InputGroup } from 'react-bootstrap';
import { FaCopy } from 'react-icons/fa';
import { FiShare2 } from 'react-icons/fi';

/**
 *
 * generateGuestInviteURL
 *
 * creates a url for the guest to use to invite another person to fill their guest
 * form
 *
 */
export function generateGuestClaimURL(spaceID: string, accessCode: string) {
  // testing urls
  const defaultURL = process.env.VERCEL_URL
    ? `https://${process.env.VERCEL_URL}`
    : 'http://localhost:3000';

  const websiteURL =
    process.env.NEXT_PUBLIC_ENVIRONMENT === 'prod'
      ? 'https://www.skyhookadventure.com'
      : defaultURL;

  const url = new URL(
    `guest/claim?spaceID=${spaceID}&accessCode=${accessCode}`,
    websiteURL,
  );
  return url.href;
}

type Props = {
  spaceID: string;
  accessCode: string;
};

export default function InviteGuest({ spaceID, accessCode }: Props) {
  const [isCopied, setIsCopied] = useState(false);

  // this invite code can be sent to the guest to claim their trip
  const guestClaimURL = generateGuestClaimURL(spaceID, accessCode);

  // is webShare supported
  const isWebShareSupported = useMemo(() => navigator.share !== undefined, []);

  const share = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          url: guestClaimURL,
          text: `Here's the trip - please can you fill in the form?`,
        });
      } catch (e) {
        alert('Something went wrong!');
      }
    }
  };

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(guestClaimURL);
      alert('Copied to clipboard!');
      setIsCopied(true);
    } catch (e) {
      alert('Something went wrong!');
    }
  };

  return (
    <>
      {isWebShareSupported ? (
        <Button
          type="button"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            share();
          }}
          size="sm"
          className="me-1 mb-1"
        >
          <FiShare2 className="me-2" style={{ marginTop: -3 }} />
          <span>Send to friend</span>
        </Button>
      ) : (
        <InputGroup>
          <FormControl
            id="guestClaimURL"
            value={guestClaimURL}
            aria-label="guest claim url"
            style={{ display: 'none' }}
          />
          <Button
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              copyLink();
            }}
            size="sm"
            className="me-1 mb-1 py-1"
          >
            <FaCopy className="me-2" style={{ marginTop: -3 }} />
            <span>{isCopied ? 'Copied' : 'Copy link for friend'} </span>
          </Button>
        </InputGroup>
      )}
    </>
  );
}
